import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const stackBoardBarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'z', type: 'array', required: true }
  ],
  businessRules: [
    {
      name: 'stack-board-bar-sufficient-data',
      validator: data => data.length >= 2,
      message: 'Stack board bar chart requires at least 2 data points',
      suggestion: 'Provide at least 2 data points for meaningful comparison',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'stack-board-bar-trend-data',
      validator: (data, layer) => {
        const { encoding } = layer;
        // 检查z字段的趋势数据是否充分
        return data.every(item => {
          const zData = item[encoding?.z as string];
          return Array.isArray(zData) && zData.length >= 2;
        });
      },
      message: 'Stack board bar chart requires trend data with at least 2 points in z field',
      suggestion:
        'Ensure each z-field array contains at least 2 data points for trend visualization',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    },
    {
      name: 'stack-board-bar-trend-quality',
      validator: (data, layer) => {
        const { encoding } = layer;
        // 检查趋势数据质量（建议有3+个点）
        const goodTrendCount = data.filter(item => {
          const zData = item[encoding?.z as string];
          return Array.isArray(zData) && zData.length >= 3;
        }).length;

        // 至少50%的数据有良好的趋势
        return goodTrendCount >= data.length * 0.5;
      },
      message: 'Stack board bar chart works best with richer trend data (3+ points per trend)',
      suggestion: 'Consider providing more data points in trend arrays for better visualization',
      // 推荐性建议，不影响图表渲染
      severity: 'warning'
    }
  ]
};
